export default "__VITE_ASSET__CISlkU4e__"